<template>
  <div class="tg-btn--radio">
    <template v-for="(item, i) in items">
      <div :key="i" :class="['radio-item', { active: selected == item.value }]">
        <i v-if="item.icon">
          <font-awesome-icon :icon="item.icon" size="1x"></font-awesome-icon>
        </i>
        <span @click="handleClick(item)">{{ $t(item.langKey) }}</span>
      </div>
      <template v-if="i < items.length - 1">
        <el-divider :key="'divider' + i" direction="vertical"></el-divider>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    value: [String, Number],
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    if (this.value) {
      this.selected = this.value;
    } else {
      this.selected = this.items[0] ? this.items[0].value : null;
    }
  },
  methods: {
    handleClick(item) {
      this.selected = item.value;
      this.$emit("on-click", item.value);
    },
  },
};
</script>